import React, { useState, useEffect } from 'react'; // Fix the capital 'R' in 'React'
import { useDispatch, useSelector } from 'react-redux';
import { Row, Layout, List, Typography, Space, Drawer } from 'antd'; // Add List and Typography for file listing
import Button from '@mui/material/Button'; // Fix the import statement
import {UploadFileRounded} from "@mui/icons-material";
import { listFiles, uploadFiles } from '../../api/filesApi';
import FileUpload from '../../components/Files/FileUpload';
import FileExplorer from "./components/FileExplorer";
import Placeholder from "../../components/Placeholder";
import PageHeader from "../../components/PageHeader";
import {iconMapping} from "../../configs/AppsConfig";

/**
 *
 * @param fullscreen {boolean} - Whether to display the component in fullscreen mode
 * @param onSelect {function} - Callback function to handle file selection (must accept an array of file paths)
 * @param maxSelect {number, optional} - Maximum number of files that can be selected
 * @param whitelistExtensions {array, optional} - Array of file extensions to whitelist
 * @returns {JSX.Element}
 * @constructor
 */
const Files = ({fullscreen=true, onSelect, maxSelect, whitelistExtensions }) => {
    const dispatch = useDispatch();
    const files = useSelector(state => state.user.files); // Accessing files from the Redux state
    const filesLoaded = useSelector(state => state.user.filesLoaded); // Accessing the filesLoaded state
    const status = useSelector(state => state.user.status); // Accessing the status for loading indicators
    const [showUpload, setShowUpload] = useState(false);
    const [uploadPath, setUploadPath] = useState(''); // Setting the default upload path to root



    useEffect(() => {
        if (!filesLoaded) dispatch(listFiles()); // Dispatch listFiles to load files on component mount
    });

    const initFileUploadFromExplorer = (path) => {
        console.log('Initiating file upload from explorer...', path);
        setShowUpload(true);
        setUploadPath(path);
    }

    const handleFileUpload = async (newFiles) => {
        console.log(newFiles);

        dispatch(uploadFiles({ files: newFiles, folderPath: uploadPath })); // Dispatch action to upload files
    };

    return (
        <Layout>
            <PageHeader title={'File Cloud'} logoUrl={iconMapping.files} />
            <Layout.Content style={{padding: 50}}>
                {status === 'loading' && <p>Loading files...</p>}
                {files && files.length > 0 ? (
                    <FileExplorer
                        resources={files}
                        handleSelect={onSelect}
                        fullscreen={fullscreen}
                        maxSelect={maxSelect}
                        whitelistExtensions={whitelistExtensions}
                        onUpload={initFileUploadFromExplorer}

                    />
                ) : <Placeholder text={'No Files Found...'}
                                 action={<Button onClick={()=>setShowUpload(true)}
                                                color={'info'}
                                                variant={'contained'}
                                        >
                                            Start Uploading Now
                                        </Button>
                                 }
                    />
                }
            </Layout.Content>
            <Drawer
                width={700}
                open={showUpload}
                onClose={()=>setShowUpload(false)}
            >
                <FileUpload onFileUpload={handleFileUpload} />
            </Drawer>
        </Layout>
    );
};

export default Files;
